import React from 'react';
import Header from './Header';
import Footer from './Footer';
import '../css/Timeline.css';
import '../css/About.css';
import {timelineData} from '../json_data/timeline.js';

const TimelineItem=({data})=>{
    return(
        <div class="timeline-item">
            <div className="timeline-item-content">
                <div className="body-header">
                    <div classname="body-header-title">
                        <div class="body-card-title">
                            <h2>{data.degree}</h2>
                        </div>
                        <div className="body-header-duration">
                            <h3>{data.startYear}-{data.endYear}</h3>
                        </div>
                    </div>
                    <div class="card-subtitle">
                        <h4>
                        <h3>{data.college}</h3>{data.marks}
                        </h4>
                    </div>
                </div>
                <span className="marker"></span>
                <div class="body-content"></div>
            </div>
        </div>
    );
};

function Timeline(){
    return(
        <div>
            <Header/>
            <div>
                <div class="heading">
                    Education
                </div>
                <div class="timeline-start"></div>
                {timelineData.length>0 && (
                    <div className="timeline-container">
                        {timelineData.map((data,idx)=>(
                            <TimelineItem data={data} key={idx}/>
                        ))}
                    </div>
                )}
                <div class="timeline-end"></div>
            </div>
            <Footer/>
        </div>
    );
}
export default Timeline;